import * as StyledComponents from '../StyledComponents';

export const CampaignLinkTextInputWithHelperText = ({
  helperLabel,
  textLength,
  ...props
}: any): JSX.Element => {
  return (
    <StyledComponents.StyledLinkTextContainer>
      <StyledComponents.StyledNameAndLinkTextArea {...props} />
      <StyledComponents.StyledNameHelperLabelContainer>
        <StyledComponents.StyledNameHelperLabel>
          {helperLabel}
        </StyledComponents.StyledNameHelperLabel>
        {textLength?.length &&
        <StyledComponents.StyledNameCountLabel>
          {textLength}
        </StyledComponents.StyledNameCountLabel>}
      </StyledComponents.StyledNameHelperLabelContainer>
    </StyledComponents.StyledLinkTextContainer>
  );
};
